module.exports = __webpack_public_path__ + "static/img/game-level3.56e107c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/game/game-level3.png
// module id = dpyT
// module chunks = 1